import styled from "styled-components";

import { COLOR_VALUES } from "shared/config/colors";

export const StyledPopOver = styled.div`
    background: white;
    padding: 0;
    overflow: auto;
    background: #ffffff;
    border: 1px solid #e5e8ec;
    border-radius: 4px;
    margin-top: ${(props) => props.$marginTop}px;
    margin-bottom: ${(props) => props.$marginTop}px;

    &::-webkit-scrollbar {
        width: 8px;
        border-left: 1px solid ${COLOR_VALUES.Gray_6};
    }

    &::-webkit-scrollbar-thumb {
        background-color: ${COLOR_VALUES.Gray_5};
        border: 2px solid rgba(0, 0, 0, 0);
        background-clip: padding-box;
        border-radius: 999px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background-color: ${COLOR_VALUES.Gray_6};
    }
`;
